<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Calculation.Title }}
            <span class="subtitle hero-subtitle">{{ $lang.Calculation.NewTitle_3 }}</span>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-catalog-request" icon-left="plus-box-outline" @click="openCircuitDevices">{{ [$lang.Calculation.InnerTitle_14, $lang.Calculation.InnerTitle_15, $lang.Calculation.InnerTitle_16].join(' ') }}</b-button>
            </p>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body calc-body">
                <calculationTabs />
                <outputCircBtns />

                <!-- The incoming device: each level appears once the catalogue has a choice for it. -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_5 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.TableDefinition">
                            <b-input v-model="definition_2"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Type" :type="{ 'is-danger': hasError_type }" :message="emptyWarning_type">
                            <b-select v-model="type" expanded @input="getCircuitDevice_Brands">
                                <option v-for="option in typesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Brand" :type="{ 'is-danger': hasError_brand }" :message="emptyWarning_brand">
                            <b-select v-model="brand" expanded @input="getCircuitDevice_Codes">
                                <option v-for="option in brandsList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Code" :type="{ 'is-danger': hasError_code }" :message="emptyWarning_code">
                            <b-select v-model="code" expanded @input="getCircuitDevice_Ins">
                                <option v-for="option in codesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isIn_AVisible" :type="{ 'is-danger': hasError_in_A }" :message="emptyWarning_in_A">
                            <template #label><span v-html="$lang.CalcCircInfos.In_A"></span></template>
                            <b-select v-model="in_A" expanded @input="getCircuitDevice_Pole">
                                <option v-for="option in in_valList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPoleNumVisible" :label="$lang.CalcCircInfos.PoleNumber" :type="{ 'is-danger': hasError_poleNumber }" :message="emptyWarning_poleNumber">
                            <b-select v-model="poleNumber" expanded @input="getCircuitDevice_Sbt_Cekmeceli">
                                <option v-for="option in poleList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="is_sbt_cekmeceliVisible" :label="$lang.CalcCircInfos.Sbt_cekmeceli" :type="{ 'is-danger': hasError_sbt_cekmeceli }" :message="emptyWarning_sbt_cekmeceli">
                            <b-select v-model="sbt_cekmeceli" expanded @input="getCircuitDevice_Power">
                                <option v-for="option in sbt_cekmeceliList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPowerVisible" :label="$lang.CalcCircInfos.Power" :type="{ 'is-danger': hasError_power }" :message="emptyWarning_power">
                            <b-select v-model="power" expanded @input="getCircuitDevice_Pv">
                                <option v-for="option in powerList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.CalcAddButton" @click="addToInputCircuitAndConductor" />
                    </div>
                </div>

                <!-- Its connecting conductor: what the user picks, then what follows from it (greyed). -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_6 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.TableDefinition">
                            <b-input v-model="definition_3"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConnType" :type="{ 'is-danger': hasError_connType }" :message="emptyWarning_connType">
                            <b-select v-model="connType" expanded @input="getCablePositions">
                                <option v-for="option in connTypeList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isCablePosVisible" :label="$lang.CalcCircInfos.CablePos" :type="{ 'is-danger': hasError_cablePos }" :message="emptyWarning_cablePos">
                            <b-select v-model="cablePos" expanded @input="getConductorDimensions">
                                <option v-for="option in cablePosList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber" :type="{ 'is-danger': hasError_phaseNumber_3 }" :message="emptyWarning_phaseNumber_3">
                            <b-select v-model="phaseNumber_3" expanded>
                                <option v-for="option in phaseNumber_3_List" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorDimension" :type="{ 'is-danger': hasError_conductorDimension }" :message="emptyWarning_conductorDimension">
                            <b-select v-model="conductorDimension" expanded @input="getConductor_Imax_and_Power">
                                <option v-for="option in condDimensionList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_conductorLength_3 }" :message="emptyWarning_conductorLength_3">
                            <b-input v-model="conductorLength_3" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_3" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_3" type="number" disabled></b-input>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.CalcAddButton" @click="addToInputCircuitDeviceConductors" />
                    </div>
                </div>

                <!-- The total covers devices and conductors: it was shown only once a conductor was added. -->
                <template v-if="circuitcalculationdevicesdata.length != 0 || conductordevicesdata.length != 0">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_7 }}</p>
                    <div class="calc-table-card">
                        <b-table v-if="circuitcalculationdevicesdata.length != 0" class="data-table is-flush" :data="circuitcalculationdevicesdata">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                {{ props.row.Definition }}
                            </b-table-column>
                            <b-table-column field="Type" :label="$lang.CalcCircInfos.Type" v-slot="props">
                                {{ props.row.Type }}
                            </b-table-column>
                            <b-table-column field="Brand" :label="$lang.CalcCircInfos.Brand" v-slot="props">
                                {{ props.row.Brand }}
                            </b-table-column>
                            <b-table-column field="Code" :label="$lang.CalcCircInfos.Code" v-slot="props">
                                {{ props.row.Code }}
                            </b-table-column>
                            <b-table-column field="In_Value">
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.In_A"></span></template>
                                <template v-slot="props">{{ props.row.In_Value }}</template>
                            </b-table-column>
                            <b-table-column field="Pole" :label="$lang.CalcCircInfos.PoleNumber" v-slot="props">
                                {{ props.row.Pole }}
                            </b-table-column>
                            <b-table-column field="Sbt_Cekmeceli" :label="$lang.CalcCircInfos.Sbt_cekmeceli" v-slot="props">
                                {{ props.row.Sbt_Cekmeceli }}
                            </b-table-column>
                            <b-table-column field="Power" :label="$lang.CalcCircInfos.Power" v-slot="props">
                                {{ props.row.Power }}
                            </b-table-column>
                            <b-table-column field="Pv" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>
                                <template v-slot="props">{{ truncate(props.row.Pv, 1) }}</template>
                            </b-table-column>
                            <b-table-column field="Action" v-slot="props" width="164">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateInputCircuitCalcDeviceModal(props.row)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromInputCircuitCalcDevices(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromInputCircuitCalcDevices(props.row)">
                                        <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                        </b-table>
                        <b-table v-if="conductordevicesdata.length != 0" class="data-table is-flush" :class="{ 'is-joined': circuitcalculationdevicesdata.length != 0 }" :data="conductordevicesdata">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                {{ props.row.Definition }}
                            </b-table-column>
                            <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" v-slot="props">
                                {{ props.row.ConnectionType }}
                            </b-table-column>
                            <b-table-column v-if="hasCableRows" field="CablePosition" :label="$lang.CalcCircInfos.CablePos" v-slot="props">
                                {{ props.row.CablePosition }}
                            </b-table-column>
                            <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" v-slot="props">
                                {{ props.row.PhaseNumber }}
                            </b-table-column>
                            <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" v-slot="props">
                                {{ props.row.DimensionInfo }}
                            </b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" v-slot="props" numeric>
                                {{ props.row.ConductorLength }}
                            </b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" v-slot="props" numeric>
                                {{ props.row.ConductorTemperature }}
                            </b-table-column>
                            <b-table-column field="MaxTemperature" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                                <template v-slot="props">{{ props.row.MaxTemperature }}</template>
                            </b-table-column>
                            <b-table-column field="I_Max" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                                <template v-slot="props">{{ truncate(props.row.I_Max, 1) }}</template>
                            </b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" v-slot="props" numeric>
                                {{ truncate(props.row.LostPower, 1) }}
                            </b-table-column>
                            <b-table-column field="CalcResult" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>
                                <template v-slot="props">{{ truncate(props.row.CalcResult, 1) }}</template>
                            </b-table-column>
                            <b-table-column field="Action" v-slot="props" width="164">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openInputCircuitDeviceConductorModal(props.row)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromInputCircuitDeviceConductors(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromInputCircuitDeviceConductors(props.row)">
                                        <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                        </b-table>
                        <div class="calc-total">
                            <span>{{ $lang.CalcCircInfos.Total_P_InpCirc }}</span>
                            <b>{{ truncate(total_P_InputCircuit, 1) }}</b>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Edit a device. It shares the add form's fields; the form is kept and given back. -->
        <b-modal v-model="isInputCircuitDeviceUpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdateDevice }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.TableDefinition">
                            <b-input v-model="definition_2"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Type" :type="{ 'is-danger': hasError_type }" :message="emptyWarning_type">
                            <b-select v-model="type" expanded @input="getCircuitDevice_Brands">
                                <option v-for="option in typesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Brand" :type="{ 'is-danger': hasError_brand }" :message="emptyWarning_brand">
                            <b-select v-model="brand" expanded @input="getCircuitDevice_Codes">
                                <option v-for="option in brandsList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Code" :type="{ 'is-danger': hasError_code }" :message="emptyWarning_code">
                            <b-select v-model="code" expanded @input="getCircuitDevice_Ins">
                                <option v-for="option in codesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isIn_AVisible" :type="{ 'is-danger': hasError_in_A }" :message="emptyWarning_in_A">
                            <template #label><span v-html="$lang.CalcCircInfos.In_A"></span></template>
                            <b-select v-model="in_A" expanded @input="getCircuitDevice_Pole">
                                <option v-for="option in in_valList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPoleNumVisible" :label="$lang.CalcCircInfos.PoleNumber" :type="{ 'is-danger': hasError_poleNumber }" :message="emptyWarning_poleNumber">
                            <b-select v-model="poleNumber" expanded @input="getCircuitDevice_Sbt_Cekmeceli">
                                <option v-for="option in poleList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="is_sbt_cekmeceliVisible" :label="$lang.CalcCircInfos.Sbt_cekmeceli" :type="{ 'is-danger': hasError_sbt_cekmeceli }" :message="emptyWarning_sbt_cekmeceli">
                            <b-select v-model="sbt_cekmeceli" expanded @input="getCircuitDevice_Power">
                                <option v-for="option in sbt_cekmeceliList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPowerVisible" :label="$lang.CalcCircInfos.Power" :type="{ 'is-danger': hasError_power }" :message="emptyWarning_power">
                            <b-select v-model="power" expanded @input="getCircuitDevice_Pv">
                                <option v-for="option in powerList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeDeviceModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateInputCircuitCalcDevices()" />
                </footer>
            </div>
        </b-modal>

        <!-- Edit a conductor, the same way. -->
        <b-modal v-model="isConductorDeviceUpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdateDeviceConductor }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.TableDefinition">
                            <b-input v-model="definition_3"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConnType" :type="{ 'is-danger': hasError_connType }" :message="emptyWarning_connType">
                            <b-select v-model="connType" expanded @input="getCablePositions">
                                <option v-for="option in connTypeList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isCablePosVisible" :label="$lang.CalcCircInfos.CablePos" :type="{ 'is-danger': hasError_cablePos }" :message="emptyWarning_cablePos">
                            <b-select v-model="cablePos" expanded @input="getConductorDimensions">
                                <option v-for="option in cablePosList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber" :type="{ 'is-danger': hasError_phaseNumber_3 }" :message="emptyWarning_phaseNumber_3">
                            <b-select v-model="phaseNumber_3" expanded>
                                <option v-for="option in phaseNumber_3_List" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorDimension" :type="{ 'is-danger': hasError_conductorDimension }" :message="emptyWarning_conductorDimension">
                            <b-select v-model="conductorDimension" expanded @input="getConductor_Imax_and_Power">
                                <option v-for="option in condDimensionList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_conductorLength_3 }" :message="emptyWarning_conductorLength_3">
                            <b-input v-model="conductorLength_3" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_3" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_3" type="number" disabled></b-input>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeConductorModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateInputCircuitDeviceConductors()" />
                </footer>
            </div>
        </b-modal>

        <b-loading v-if="isLoading" :is-full-page="true" :active="true" :can-cancel="false"></b-loading>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { storeLossTotals } from '@/api/lossTotals';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import OutputCircBtns from '@/components/OutputCircBtns.vue';
    import CalculationTabs from '@/components/CalculationTabs.vue';
    import keepFormDuringEdit from '@/mixins/keepFormDuringEdit';

    const DIGIT_EXPRESSION = /^\d$/;

    const isDigit = (character) => {
        return character && DIGIT_EXPRESSION.test(character);
    };

    // Unchosen: a select can hand back null as well as '', and null == '' is false.
    //
    // The cascade handlers below return on an unchosen value. Vue's select v-model reports a
    // change by itself when a select's options change and its value is not among them, so
    // a reset (or a closed dialog giving the form back) called them with nothing chosen,
    // and the catalogue was asked for id 0 - a 500 and an error dialog each.
    const isEmpty = (value) => value === '' || value === null || value === undefined;

    // A catalogue level the user chooses: one that has values, and not only "NA".
    const offersChoice = (list) => list.length > 0 && !(list.length == 1 && list[0] == 'NA');

    // What the edit dialogs share with the add forms (see mixins/keepFormDuringEdit).
    const DEVICE_FORM = ['definition_2', 'type', 'brand', 'code', 'in_A', 'poleNumber', 'sbt_cekmeceli', 'power', 'Pv',
        'brandsList', 'codesList', 'in_valList', 'poleList', 'sbt_cekmeceliList', 'powerList',
        'isIn_AVisible', 'isPoleNumVisible', 'is_sbt_cekmeceliVisible', 'isPowerVisible',
        'hasError_type', 'emptyWarning_type', 'hasError_brand', 'emptyWarning_brand', 'hasError_code', 'emptyWarning_code',
        'hasError_in_A', 'emptyWarning_in_A', 'hasError_poleNumber', 'emptyWarning_poleNumber',
        'hasError_sbt_cekmeceli', 'emptyWarning_sbt_cekmeceli', 'hasError_power', 'emptyWarning_power'];
    const CONDUCTOR_FORM = ['definition_3', 'in_A', 'connType', 'cablePos', 'phaseNumber_3', 'conductorDimension', 'conductorLength_3',
        'Imax_3', 'lostPower_3', 'p_conductor', 'cablePosList', 'phaseNumber_3_List', 'condDimensionList', 'isCablePosVisible',
        'hasError_connType', 'emptyWarning_connType', 'hasError_cablePos', 'emptyWarning_cablePos',
        'hasError_phaseNumber_3', 'emptyWarning_phaseNumber_3', 'hasError_conductorDimension', 'emptyWarning_conductorDimension',
        'hasError_conductorLength_3', 'emptyWarning_conductorLength_3'];

    export default {
        name: 'Calc_InputCircuit',
        mixins: [keepFormDuringEdit],
        components: {
            VerticalStepBar,
            OutputCircBtns,
            CalculationTabs
        },
        data() {
            return {
                isActive: true,
                labelPosition: 'on-border',
                isLoading: false,
                projectId: 0,
                currentPage: 1,
                circuitcalculationdevicesdata: [],
                conductordevicesdata: [],
                total_P_InputCircuit: 0,
                conductorTemp: 70,
                Tmax_inPanel: 0,

                inputCircuitCalcDeviceId: 0,
                definition_2: this.$lang.Calculation.Input + ' 1',
                definitionIndex_2: 0,
                type: '',
                typesList: [],
                brand: '',
                brandsList: [],
                code: '',
                codesList: [],
                in_A: '',
                in_valList: [],
                poleNumber: '',
                poleList: [],
                isPoleNumVisible: false,
                sbt_cekmeceli: '',
                sbt_cekmeceliList: [],
                is_sbt_cekmeceliVisible: false,
                power: '',
                powerList: [],
                isPowerVisible: false,
                Pv: 0,
                pvList: [],
                isPv_Visible: false,
                isInputCircuitDeviceUpdateModalActive: false,
                hasError_type: false,
                emptyWarning_type: '',
                hasError_brand: false,
                emptyWarning_brand: '',
                hasError_code: false,
                emptyWarning_code: '',
                hasError_in_A: false,
                emptyWarning_in_A: '',
                hasError_poleNumber: false,
                emptyWarning_poleNumber: '',
                hasError_sbt_cekmeceli: false,
                emptyWarning_sbt_cekmeceli: '',
                hasError_power: false,
                emptyWarning_power: '',
                hasError_Pv: false,
                emptyWarning_Pv: '',
                canCalculate_2: false,

                inputConductorDeviceId: 0,
                definition_3: this.$lang.Calculation.Input + ' 1',
                definitionIndex_3: 0,
                connType: '',
                connTypeList: [],
                cablePos: '',
                isCablePosVisible: false,
                cablePosList: [],
                phaseNumber_3: '',
                phaseNumber_3_List: [],
                conductorDimension: '',
                condDimensionList: [],
                conductorLength_3: 1,
                Imax_3: 0,
                lostPower_3: 0,
                p_conductor: 0,
                isConductorDeviceUpdateModalActive: false,
                hasError_connType: false,
                emptyWarning_connType: '',
                hasError_cablePos: false,
                emptyWarning_cablePos: '',
                hasError_phaseNumber_3: false,
                emptyWarning_phaseNumber_3: '',
                hasError_conductorDimension: false,
                emptyWarning_conductorDimension: '',
                hasError_conductorLength_3: false,
                emptyWarning_conductorLength_3: '',
                canCalculate_3: false,
                isIn_AVisible: false
            }
        },
        computed: {
            hasCableRows() {
                return this.conductordevicesdata.some((row) => row.CablePosition);
            }
        },
        mounted() {
            this.projectId = this.$store.state.projectId;
            this.Tmax_inPanel = this.$store.state.maxTemperature;

            this.getInputCircuitCalcDevicesTable();
            this.getInputCircuitDeviceConductorsTable();
            this.getTotal_P();

            this.getCircuitDevice_Types();
            this.getConnectionTypes();
            this.$store.state.activeStep = 3;
            this.$store.state.isFooterFixed = false;
        },
        watch: {
            $route() {

            }
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_Busbar');
            },
            submit() {
                this.saveResult();

                this.$store.isPageOpenedFromStepBar = false;
                this.$store.canResultOpen = true;

                router.push('/calc_OutputCircuit');
            },
            // The whole tool's total, from the server: see api/lossTotals.js.
            saveResult() {
                return storeLossTotals(this.$store, this.projectId).catch(() => {});
            },
            isNumber(value) {
                return typeof value === 'number';
            },
            setPositiveNumber() {
                if (this.conductorLength_3) {
                    this.conductorLength_3 = parseFloat(this.conductorLength_3.toString().replace(',', '.'));
                }

                if (this.conductorLength_3 < 0) {
                    this.conductorLength_3 = 1;
                }
            },
            // The whole device form, lists and levels with it: In (A) stayed on screen, empty.
            resetCircDevice() {
                this.type = '';
                this.brandsList = [];
                this.resetFieldList(1);
                this.isPv_Visible = false;
                this.isInputCircuitDeviceUpdateModalActive = false;
            },
            resetConductor() {
                this.connType = '';
                this.cablePos = '';
                this.phaseNumber_3 = '';
                this.conductorDimension = '';
                this.conductorLength_3 = 1;
                this.Imax_3 = 0;
                this.lostPower_3 = 0;
                this.p_conductor = 0;
                this.isConductorDeviceUpdateModalActive = false;
            },
            // A choice clears itself and every level under it, and those levels stay hidden until
            // the catalogue answers. The resets ran a level low: a new code kept the old In, a new
            // In the old pole, and so on, and the next request went out with the stale value.
            resetFieldList(index) {
                const levels = [
                    ['brand', 'brandsList', null],
                    ['code', 'codesList', null],
                    ['in_A', 'in_valList', 'isIn_AVisible'],
                    ['poleNumber', 'poleList', 'isPoleNumVisible'],
                    ['sbt_cekmeceli', 'sbt_cekmeceliList', 'is_sbt_cekmeceliVisible'],
                    ['power', 'powerList', 'isPowerVisible']
                ];
                levels.slice(index - 1).forEach(([value, list, visible], i) => {
                    this[value] = '';
                    if (i > 0) {
                        this[list] = [];
                    }
                    if (visible) {
                        this[visible] = false;
                    }
                });
                this.Pv = 0;
            },
            // The same for the conductor; I max and its loss follow the section, so they go with it.
            resetFieldList_2(index) {
                if (index <= 1) {
                    this.cablePos = '';
                }
                if (index <= 2) {
                    this.phaseNumber_3 = '';
                }
                this.conductorDimension = '';
                this.Imax_3 = 0;
                this.lostPower_3 = 0;
            },

            getTotal_P() {
                return Promise.all([
                    api.panels.getTotal_P_InputCircuitCalculationDevices(this.projectId),
                    api.panels.getTotal_P_InputCircuitDeviceConductors(this.projectId)
                ]).then(([devices, conductors]) => {
                    const failed = [devices, conductors].find((res) => res.isError);
                    if (failed) {
                        this.$buefy.dialog.alert(this.$errorModal(failed));
                        return;
                    }
                    this.total_P_InputCircuit = (parseFloat(devices.data) || 0) + (parseFloat(conductors.data) || 0);
                    this.saveResult();
                });
            },

            getInputCircuitCalcDevicesTable() {
                this.circuitcalculationdevicesdata = [];
                api.panels.getInputCircuitCalcDevices(this.projectId).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        var digitList = [];
                        res.data.forEach((e) => {
                            this.circuitcalculationdevicesdata.push(e);

                            var last = e.Definition.charAt(e.Definition.length - 1);
                            if (isDigit(last)) {
                                digitList.push(parseInt(last));
                            }
                        });

                        var maxDigit = 0;
                        for (let i = 0; i < digitList.length; i++) {
                            if (maxDigit < digitList[i]) {
                                maxDigit = digitList[i];
                            }
                        }

                        this.definitionIndex_2 = maxDigit + 1;
                        this.definition_2 = this.$lang.Calculation.Input + " " + this.definitionIndex_2;
                    }
                });
            },
            addToInputCircuitCalcDevices() {
                this.controlInputs_2();
                this.getCircuitDevice_Pv();
                if (this.canCalculate_2) {
                    const device = {
                        ProjectId: this.projectId,
                        Definition: this.definition_2,
                        Type: this.type,
                        Brand: this.brand,
                        Code: this.code,
                        In_Value: this.in_A,
                        Pole: this.poleNumber,
                        Sbt_Cekmeceli: this.sbt_cekmeceli,
                        Power: this.power,
                        Pv: this.Pv
                    };

                    api.panels.addToInputCircuitCalcDevices(device).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            this.$buefy.toast.open(this.$lang.OtherDialog.Added);
                            this.getInputCircuitCalcDevicesTable();
                            this.getTotal_P();
                            this.resetCircDevice();
                        }
                    });
                }
            },
            deleteFromInputCircuitCalcDevices(device) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.deleteFromInputCircuitCalcDevices(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                                this.getInputCircuitCalcDevicesTable();
                                this.getTotal_P();
                            }
                        })
                })
            },
            copyFromInputCircuitCalcDevices(device) {
                var initialDefinition = device.Definition;
                device.Definition = device.Definition + " " + this.$lang.CopyDialog.Extension;
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToInputCircuitCalcDevices(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                                this.getInputCircuitCalcDevicesTable();
                                this.getTotal_P();
                            }
                        }),
                    onCancel: () => {
                        device.Definition = initialDefinition;
                    }
                })
            },
            // The row's choices at every level, fetched together (each depends only on the row), and
            // the dialog opens once they are in. The power level was shown the wrong way round -
            // locked when it had values, open when it was NA - and a failed step left the loader up.
            openUpdateInputCircuitCalcDeviceModal(device) {
                this.keepForm(DEVICE_FORM);
                this.isLoading = true;
                const lang = this.$lang.Format.Lang;
                const panels = api.panels;
                Promise.all([
                    panels.getCircuitDevice_Brands(device.Type, lang),
                    panels.getCircuitDevice_Codes(device.Brand, device.Type, lang),
                    panels.getCircuitDevice_Ins(device.Brand, device.Type, device.Code, lang),
                    panels.getCircuitDevice_Pole(device.Brand, device.Type, device.Code, device.In_Value, lang),
                    panels.getCircuitDevice_Sbt_Cekmeceli(device.Brand, device.Type, device.Code, device.In_Value, device.Pole, lang),
                    panels.getCircuitDevice_Power(device.Brand, device.Type, device.Code, device.In_Value, device.Pole, device.Sbt_Cekmeceli, lang)
                ]).then((answers) => {
                    const failed = answers.find((res) => res.isError);
                    if (failed) {
                        this.restoreForm();
                        this.$buefy.dialog.alert(this.$errorModal(failed));
                        return;
                    }
                    const [brands, codes, ins, poles, sbts, powers] = answers.map((res) => res.data);
                    this.brandsList = brands;
                    this.codesList = codes;
                    this.in_valList = ins;
                    this.poleList = poles;
                    this.sbt_cekmeceliList = sbts;
                    this.powerList = powers;
                    this.isIn_AVisible = offersChoice(ins);
                    this.isPoleNumVisible = offersChoice(poles);
                    this.is_sbt_cekmeceliVisible = offersChoice(sbts);
                    this.isPowerVisible = offersChoice(powers);

                    this.inputCircuitCalcDeviceId = device.Id;
                    this.definition_2 = device.Definition;
                    this.type = device.Type;
                    this.brand = device.Brand;
                    this.code = device.Code;
                    this.in_A = device.In_Value;
                    this.poleNumber = device.Pole;
                    this.sbt_cekmeceli = device.Sbt_Cekmeceli;
                    this.power = device.Power;
                    this.Pv = device.Pv;
                    this.isInputCircuitDeviceUpdateModalActive = true;
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            closeDeviceModal() {
                this.isInputCircuitDeviceUpdateModalActive = false;
                this.restoreForm();
            },
            // Checked as an add is, and sent with the dialog's definition: it sent definition_1,
            // which this screen does not have (the server did not save the name either, until
            // Update_InputCircuitCalculationDevices took it), so a renamed device kept its old name.
            updateInputCircuitCalcDevices() {
                this.controlInputs_2();
                if (!this.canCalculate_2) {
                    return;
                }
                const device = {
                    Id: this.inputCircuitCalcDeviceId,
                    ProjectId: this.projectId,
                    Definition: this.definition_2,
                    Type: this.type,
                    Brand: this.brand,
                    Code: this.code,
                    In_Value: this.in_A,
                    Pole: this.poleNumber,
                    Sbt_Cekmeceli: this.sbt_cekmeceli,
                    Power: this.power,
                    Pv: this.Pv
                };
                api.panels.updateInputCircuitCalcDevices(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeDeviceModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.getInputCircuitCalcDevicesTable();
                        this.getTotal_P();
                    }
                });
            },
            getCircuitDevice_Types() {
                this.typesList = [];
                var langCode = this.$lang.Format.Lang;
                api.panels.getCircuitDevice_Types_InputCircs(langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.typesList.push(e);
                        });
                    }
                });
            },
            getCircuitDevice_Brands() {
                if (isEmpty(this.type)) {
                    return;
                }
                this.brandsList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Brands(this.type, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.brandsList.push(e);
                        });
                    }
                });
                this.resetFieldList(1);
            },
            getCircuitDevice_Codes() {
                if (isEmpty(this.brand)) {
                    return;
                }
                this.codesList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Codes(this.brand, this.type, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.codesList.push(e);
                        });
                    }
                });
                this.resetFieldList(2);
            },
            getCircuitDevice_Ins() {
                if (isEmpty(this.code)) {
                    return;
                }
                this.in_valList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Ins(this.brand, this.type, this.code, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.in_valList.push(e);
                        });

                        if (this.in_valList.length > 0) {
                            this.isIn_AVisible = true;
                            if (this.in_valList.length == 1 && this.in_valList[0] == 'NA') {
                                this.isIn_AVisible = false;
                                this.in_A = 'NA';
                            }
                        } else {
                            this.isIn_AVisible = false;
                            this.in_A = 'NA';
                        }
                        // Only an NA level is passed over; otherwise the user's choice goes on.
                        if (!this.isIn_AVisible) {
                            this.getCircuitDevice_Pole();
                        }
                    }
                });
                this.resetFieldList(3);
            },
            getCircuitDevice_Pole() {
                if (isEmpty(this.in_A)) {
                    return;
                }
                this.poleList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Pole(this.brand, this.type, this.code, this.in_A, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.poleList.push(e);
                        });
                        if (this.poleList.length > 0) {
                            this.isPoleNumVisible = true;
                            if (this.poleList.length == 1 && this.poleList[0] == 'NA') {
                                this.isPoleNumVisible = false;
                                this.poleNumber = 'NA';
                            }
                        } else {
                            this.isPoleNumVisible = false;
                            this.poleNumber = 'NA';
                        }
                        // Only an NA level is passed over; otherwise the user's choice goes on.
                        if (!this.isPoleNumVisible) {
                            this.getCircuitDevice_Sbt_Cekmeceli();
                        }
                    }
                });
                this.resetFieldList(4);
            },
            getCircuitDevice_Sbt_Cekmeceli() {
                if (isEmpty(this.poleNumber)) {
                    return;
                }
                this.sbt_cekmeceliList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Sbt_Cekmeceli(this.brand, this.type, this.code, this.in_A, this.poleNumber, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.sbt_cekmeceliList.push(e);
                        });
                        if (this.sbt_cekmeceliList.length > 0) {
                            this.is_sbt_cekmeceliVisible = true;
                            if (this.sbt_cekmeceliList.length == 1 && this.sbt_cekmeceliList[0] == 'NA') {
                                this.is_sbt_cekmeceliVisible = false;
                                this.sbt_cekmeceli = 'NA';
                            }
                        } else {
                            this.is_sbt_cekmeceliVisible = false;
                            this.sbt_cekmeceli = 'NA';
                        }
                        // Only an NA level is passed over; otherwise the user's choice goes on.
                        if (!this.is_sbt_cekmeceliVisible) {
                            this.getCircuitDevice_Power();
                        }
                    }
                });
                this.resetFieldList(5);
            },
            getCircuitDevice_Power() {
                if (isEmpty(this.sbt_cekmeceli)) {
                    return;
                }
                this.powerList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Power(this.brand, this.type, this.code, this.in_A, this.poleNumber, this.sbt_cekmeceli, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.powerList.push(e);
                        });
                        if (this.powerList.length > 0) {
                            this.isPowerVisible = true;
                            if (this.powerList.length == 1 && this.powerList[0] == 'NA') {
                                this.isPowerVisible = false;
                                this.power = 'NA';
                            }
                        } else {
                            this.isPowerVisible = false;
                            this.power = 'NA';
                        }
                        // Only an NA level is passed over; otherwise the user's choice goes on.
                        if (!this.isPowerVisible) {
                            this.getCircuitDevice_Pv();
                        }
                    }
                });
                this.resetFieldList(6);
            },
            getCircuitDevice_Pv() {
                if (isEmpty(this.power)) {
                    return;
                }
                this.pvList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Pv(this.brand, this.type, this.code, this.in_A, this.poleNumber, this.sbt_cekmeceli, this.power, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.pvList.push(e);
                        });
                        if (this.pvList.length > 0) {
                            this.isPv_Visible = true;
                            this.Pv = this.pvList[0];
                        } else {
                            this.isPv_Visible = false;
                            this.Pv = null;
                        }
                    }
                });
            },
            getInputCircuitDeviceConductorsTable() {
                this.conductordevicesdata = [];
                api.panels.getInputCircuitDeviceConductors(this.projectId).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        var digitList = [];
                        res.data.forEach((e) => {
                            this.conductordevicesdata.push(e);

                            var last = e.Definition.charAt(e.Definition.length - 1);
                            if (isDigit(last)) {
                                digitList.push(parseInt(last));
                            }
                        });

                        var maxDigit = 0;
                        for (let i = 0; i < digitList.length; i++) {
                            if (maxDigit < digitList[i]) {
                                maxDigit = digitList[i];
                            }
                        }
                        this.definitionIndex_3 = maxDigit + 1;
                        this.definition_3 = this.$lang.Calculation.Input + " " + this.definitionIndex_3;
                    }
                });
            },
            calculate_P_conductor() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                api.panels.calculate_P_Conductor(connTypeIndex, this.conductorLength_3, this.lostPower_3, this.phaseNumber_3).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.p_conductor = res.data;
                    }
                });
            },
            addToInputCircuitAndConductor() {
                this.controlInputs_2();
                // this.controlInputs_3();
                var langCode = this.$lang.Format.Lang;
                if (this.canCalculate_2) {
                    this.pvList = [];
                    api.panels.getCircuitDevice_Pv(this.brand, this.type, this.code, this.in_A, this.poleNumber, this.sbt_cekmeceli, this.power, langCode).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            res.data.forEach((e) => {
                                this.pvList.push(e);
                            });
                            if (this.pvList.length > 0) {
                                this.isPv_Visible = true;
                                this.Pv = this.pvList[0];

                                const device = {
                                    ProjectId: this.projectId,
                                    Definition: this.definition_2,
                                    Type: this.type,
                                    Brand: this.brand,
                                    Code: this.code,
                                    In_Value: this.in_A,
                                    Pole: this.poleNumber,
                                    Sbt_Cekmeceli: this.sbt_cekmeceli,
                                    Power: this.power,
                                    Pv: this.Pv
                                };
                                api.panels.addToInputCircuitCalcDevices(device).then((res) => {
                                    if (res.isError) {
                                        this.$buefy.dialog.alert(this.$errorModal(res));
                                    } else {
                                        this.$buefy.toast.open(this.$lang.OtherDialog.Added);
                                        this.getInputCircuitCalcDevicesTable();
                                        this.getTotal_P();
                                        // this.addToInputCircuitDeviceConductors();
                                    }
                                });
                            }
                        }
                    });
                }
            },
            // Checked before P is asked for: an empty form sent the server nothing to work with.
            addToInputCircuitDeviceConductors() {
                this.controlInputs_3();
                if (!this.canCalculate_3) {
                    return;
                }
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                api.panels.calculate_P_Conductor(connTypeIndex, this.conductorLength_3, this.lostPower_3, this.phaseNumber_3).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.p_conductor = res.data;
                        const device = {
                            ProjectId: this.projectId,
                            Definition: this.definition_3,
                            ConnectionType: this.connType,
                            CablePosition: this.cablePos,
                            PhaseNumber: this.phaseNumber_3,
                            DimensionInfo: this.conductorDimension,
                            ConductorLength: this.conductorLength_3,
                            ConductorTemperature: this.conductorTemp,
                            MaxTemperature: this.Tmax_inPanel,
                            I_Max: this.Imax_3,
                            LostPower: this.lostPower_3,
                            CalcResult: this.p_conductor,
                            In_Value: this.in_A
                        };

                        api.panels.addToInputCircuitDeviceConductors(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.OtherDialog.Added);
                                this.getInputCircuitDeviceConductorsTable();
                                this.getTotal_P();
                                this.resetConductor();
                                this.resetCircDevice();
                            }
                        });
                    }
                });
            },
            deleteFromInputCircuitDeviceConductors(device) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.deleteFromInputCircuitDeviceConductors(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                                this.getInputCircuitDeviceConductorsTable();
                                this.getTotal_P();
                            }
                        })
                })
            },
            copyFromInputCircuitDeviceConductors(device) {
                var initialDefinition = device.Definition;
                device.Definition = device.Definition + " " + this.$lang.CopyDialog.Extension;
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToInputCircuitDeviceConductors(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                                this.getInputCircuitDeviceConductorsTable();
                                this.getTotal_P();
                            }
                        }),
                    onCancel: () => {
                        device.Definition = initialDefinition;
                    }
                })
            },
            // The row's cable positions and phase counts, then its sections, before the dialog opens:
            // it asked for the sections before the positions had arrived, so a cable row got the
            // list for no position.
            openInputCircuitDeviceConductorModal(device) {
                this.keepForm(CONDUCTOR_FORM);
                this.isLoading = true;
                const panels = api.panels;
                const connTypeIndex = this.connTypeList.indexOf(device.ConnectionType) + 1;
                const isCable = connTypeIndex == 2;
                const fail = (res) => {
                    this.restoreForm();
                    this.$buefy.dialog.alert(this.$errorModal(res));
                };
                Promise.all([
                    isCable ? panels.getCablePositions(this.$lang.Format.Lang) : Promise.resolve({ data: [] }),
                    panels.getPhaseNumbers(connTypeIndex)
                ]).then(([positions, phases]) => {
                    const failed = [positions, phases].find((res) => res.isError);
                    if (failed) {
                        return fail(failed);
                    }
                    const cablePosList = positions.data.map((e) => e.positionName);
                    const cablePosId = cablePosList.indexOf(device.CablePosition) + 1;
                    return panels.getConductorDimensions(connTypeIndex, cablePosId, this.Tmax_inPanel).then((dimensions) => {
                        if (dimensions.isError) {
                            return fail(dimensions);
                        }
                        this.cablePosList = cablePosList;
                        this.isCablePosVisible = isCable;
                        this.phaseNumber_3_List = phases.data;
                        this.condDimensionList = dimensions.data.map((e) => e.DimensionInfo);

                        this.inputConductorDeviceId = device.Id;
                        this.in_A = device.In_Value;
                        this.definition_3 = device.Definition;
                        this.connType = device.ConnectionType;
                        this.cablePos = device.CablePosition;
                        this.phaseNumber_3 = device.PhaseNumber;
                        this.conductorDimension = device.DimensionInfo;
                        this.conductorLength_3 = device.ConductorLength;
                        this.Imax_3 = device.I_Max;
                        this.lostPower_3 = device.LostPower;
                        this.p_conductor = device.CalcResult;
                        this.isConductorDeviceUpdateModalActive = true;
                    });
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            closeConductorModal() {
                this.isConductorDeviceUpdateModalActive = false;
                this.restoreForm();
            },
            // P is worked out again, as the add does: the dialog opened with the row's old P and
            // sent it back unchanged, so a new length, section or phase count left the row's P
            // and the circuit's total as they were.
            updateInputCircuitDeviceConductors() {
                this.controlInputs_3();
                if (!this.canCalculate_3) {
                    return;
                }
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                api.panels.calculate_P_Conductor(connTypeIndex, this.conductorLength_3, this.lostPower_3, this.phaseNumber_3).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                        return;
                    }
                    this.p_conductor = res.data;
                    this.saveInputCircuitDeviceConductor();
                });
            },
            saveInputCircuitDeviceConductor() {
                const device = {
                    Id: this.inputConductorDeviceId,
                    ProjectId: this.projectId,
                    Definition: this.definition_3,
                    ConnectionType: this.connType,
                    CablePosition: this.cablePos,
                    PhaseNumber: this.phaseNumber_3,
                    DimensionInfo: this.conductorDimension,
                    ConductorLength: this.conductorLength_3,
                    ConductorTemperature: this.conductorTemp,
                    MaxTemperature: this.Tmax_inPanel,
                    I_Max: this.Imax_3,
                    LostPower: this.lostPower_3,
                    CalcResult: this.p_conductor,
                    In_Value: this.in_A
                };
                api.panels.updateInputCircuitDeviceConductors(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeConductorModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.getInputCircuitDeviceConductorsTable();
                        this.getTotal_P();
                    }
                });
            },
            getConnectionTypes() {
                this.connTypeList = [];
                var langCode = this.$lang.Format.Lang;
                api.panels.getConnectionTypes(langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.connTypeList.push(e.typeName);
                        });
                    }
                });
            },
            getCablePositions() {
                if (isEmpty(this.connType)) {
                    return;
                }
                this.cablePosList = [];
                var langCode = this.$lang.Format.Lang;
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                if (connTypeIndex == 2) {
                    this.isCablePosVisible = true;

                    api.panels.getCablePositions(langCode).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            res.data.forEach((e) => {
                                this.cablePosList.push(e.positionName);
                            });
                        }
                    });
                } else {
                    this.isCablePosVisible = false;
                    this.getConductorDimensions();
                }
                this.getPhaseNumbers();
                this.resetFieldList_2(1);
            },
            getPhaseNumbers() {
                this.phaseNumber_3_List = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                api.panels.getPhaseNumbers(connTypeIndex).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.phaseNumber_3_List.push(e);
                        });
                    }
                });
                this.resetFieldList_2(2);
            },
            getConductorDimensions() {
                if ((this.isCablePosVisible && isEmpty(this.cablePos))) {
                    return;
                }
                this.condDimensionList = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                var cablePosId = this.cablePosList.indexOf(this.cablePos) + 1;
                api.panels.getConductorDimensions(connTypeIndex, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.condDimensionList.push(e.DimensionInfo);
                        });
                    }
                });
                this.resetFieldList_2(3);
            },
            getConductor_Imax_and_Power() {
                if (isEmpty(this.conductorDimension)) {
                    return;
                }
                this.getConductor_I_Max();
                this.getConductor_LostPower();
            },
            getConductor_I_Max() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                var dimensionId = this.condDimensionList.indexOf(this.conductorDimension) + 1;
                var cablePosId = this.cablePosList.indexOf(this.cablePos) + 1;
                api.panels.getConductor_I_Max(connTypeIndex, dimensionId, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.Imax_3 = res.data;
                    }
                });
            },
            getConductor_LostPower() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                var dimensionId = this.condDimensionList.indexOf(this.conductorDimension) + 1;
                var cablePosId = this.cablePosList.indexOf(this.cablePos) + 1;
                api.panels.GetConductor_LostPower(connTypeIndex, dimensionId, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.lostPower_3 = res.data;
                    }
                });
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            },
            controlInputs_2() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate_2 = false;
                if (isEmpty(this.type)) {
                    this.hasError_type = true;
                    this.emptyWarning_type = this.$lang.Menus.EmptyWarning;
                } else if (isEmpty(this.brand)) {
                    this.hasError_brand = true;
                    this.emptyWarning_brand = this.$lang.Menus.EmptyWarning;
                } else if (isEmpty(this.code)) {
                    this.hasError_code = true;
                    this.emptyWarning_code = this.$lang.Menus.EmptyWarning;
                } else if (isEmpty(this.in_A)) {
                    this.hasError_in_A = true;
                    this.emptyWarning_in_A = this.$lang.Menus.EmptyWarning;
                } else if (isEmpty(this.poleNumber)) {
                    if (this.isPoleNumVisible) {
                        this.hasError_poleNumber = true;
                        this.emptyWarning_poleNumber = this.$lang.Menus.EmptyWarning;
                    }
                } else if (isEmpty(this.sbt_cekmeceli)) {
                    if (this.is_sbt_cekmeceliVisible) {
                        this.hasError_sbt_cekmeceli = true;
                        this.emptyWarning_sbt_cekmeceli = this.$lang.Menus.EmptyWarning;
                    }
                } else if (isEmpty(this.power)) {
                    if (this.isPowerVisible) {
                        this.hasError_power = true;
                        this.emptyWarning_power = this.$lang.Menus.EmptyWarning;
                    }
                } else {
                    this.canCalculate_2 = true;
                }

                if (!isEmpty(this.type)) {
                    this.hasError_type = false;
                    this.emptyWarning_type = '';
                }
                if (!isEmpty(this.brand)) {
                    this.hasError_brand = false;
                    this.emptyWarning_brand = '';
                }
                if (!isEmpty(this.code)) {
                    this.hasError_code = false;
                    this.emptyWarning_code = '';
                }
                if (!isEmpty(this.in_A)) {
                    this.hasError_in_A = false;
                    this.emptyWarning_in_A = '';
                }
                if (this.isPoleNumVisible && !isEmpty(this.poleNumber)) {
                    this.hasError_poleNumber = false;
                    this.emptyWarning_poleNumber = '';
                }
                if (this.is_sbt_cekmeceliVisible && !isEmpty(this.sbt_cekmeceli)) {
                    this.hasError_sbt_cekmeceli = false;
                    this.emptyWarning_sbt_cekmeceli = '';
                }
                if (this.isPowerVisible && !isEmpty(this.power)) {
                    this.hasError_power = false;
                    this.emptyWarning_power = '';
                }
            },
            controlInputs_3() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate_3 = false;
                if (isEmpty(this.connType)) {
                    this.hasError_connType = true;
                    this.emptyWarning_connType = this.$lang.Menus.EmptyWarning;
                } else if (this.isCablePosVisible && isEmpty(this.cablePos)) {
                    this.hasError_cablePos = true;
                    this.emptyWarning_cablePos = this.$lang.Menus.EmptyWarning;
                } else if (isEmpty(this.phaseNumber_3)) {
                    this.hasError_phaseNumber_3 = true;
                    this.emptyWarning_phaseNumber_3 = this.$lang.Menus.EmptyWarning;
                } else if (isEmpty(this.conductorDimension)) {
                    this.hasError_conductorDimension = true;
                    this.emptyWarning_conductorDimension = this.$lang.Menus.EmptyWarning;
                } else if (!(parseFloat(this.conductorLength_3) > 0)) {
                    this.hasError_conductorLength_3 = true;
                    this.emptyWarning_conductorLength_3 = this.conductorLength_3 === '' ? this.$lang.Menus.EmptyWarning : this.$lang.Menus.PositiveWarning;
                } else {
                    this.canCalculate_3 = true;
                }

                if (!isEmpty(this.connType)) {
                    this.hasError_connType = false;
                    this.emptyWarning_connType = '';
                }
                if (!isEmpty(this.cablePos)) {
                    this.hasError_cablePos = false;
                    this.emptyWarning_cablePos = '';
                }
                if (!isEmpty(this.phaseNumber_3)) {
                    this.hasError_phaseNumber_3 = false;
                    this.emptyWarning_phaseNumber_3 = '';
                }
                if (!isEmpty(this.conductorDimension)) {
                    this.hasError_conductorDimension = false;
                    this.emptyWarning_conductorDimension = '';
                }
                if (parseFloat(this.conductorLength_3) > 0) {
                    this.hasError_conductorLength_3 = false;
                    this.emptyWarning_conductorLength_3 = '';
                }
            },
            openCircuitDevices() {
                this.$store.state.previousRoute = this.$route.name;
                this.$store.state.isCircDevicesFromCalculation = true;
                if (this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1) {
                    router.push('/circuitDevices_Admin');
                } else {
                    router.push('/circuitDevices');
                }
            }
        }
    };
</script>
